// extracted by mini-css-extract-plugin
export default {"wordListSection":"WordListSection_wordListSection__JARtx","grid":"WordListSection_grid__KCH+a","card":"WordListSection_card__tHEFx"};